module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_food_service-99659714e78a5050adaff49b1761e150.png";